"use client";

import { getRounded } from "@/utils/theme-helper";
import parse, { Element } from "html-react-parser";

export interface SvgComponentProps {
  svg: string;
  textColor?: string;
  height?: string;
  width?: string;
  margin?: string;
  padding?: string;
  bgColor?: string;
  rounded?: string;
}

const SvgComponent: React.FC<{
  config: SvgComponentProps;
}> = ({ config }) => {
  if (!config.svg) {
    return null;
  }

  const style = `${config.height ? `height: ${config.height};` : ""} ${config.width ? `width: ${config.width};` : ""} ${config.margin ? `margin: ${config.margin};` : ""} ${config.padding ? `padding: ${config.padding};` : ""} ${config.bgColor ? `background-color: ${config.bgColor};` : ""}`;

  const parsedSvg = parse(config.svg, {
    replace: (domNode) => {
      if (domNode instanceof Element && domNode.attribs) {
        domNode.attribs["fill"] = "currentColor";
        domNode.attribs["color"] = config.textColor ?? "inherit";
        domNode.attribs["style"] = style;
        domNode.attribs["class"] = `${getRounded(config.rounded)}`;
      }
    },
  });

  return parsedSvg;
};

export default SvgComponent;
